import _get from 'lodash/get'
import _merge from 'lodash/merge'

import {patchCollectionDoesNotOwnEmailFields} from '../../_helpers/pifDoesNotOwnEmail'
import {
  resolvePifSetOneResource,
  upsertPifInCollection
} from '../../_helpers/pifFormLifecycle'
import {$axios, StoreCollection} from '../StoreCollection'

const s = {}

const dataNamespace = 'appInitialData.stores.PersonalInformationForms'

_merge(s, StoreCollection, {
  state: {
    // configure base endpoint
    apiBaseUrl: '/api/pif/v1',
    // Surface 422 validation failures to PIF form callers instead of resolving undefined.
    rejectUpdateErrors: true,

    // set Bags, there may be defaults set under window.appInitialData
    collection: _get(window, `${dataNamespace}.collection`, []),
    template: _get(window, `${dataNamespace}.template`, null),
    form: _get(window, `${dataNamespace}.form`, {})
  },
  mutations: {
    /**
     * Accept both StoreCollection shapes: plain PIF row and `{ resource }`.
     * The previous resource-only setOne made optimistic autosave commits no-ops.
     */
    setOne(state, payload) {
      const resource = resolvePifSetOneResource(payload)
      if (!resource) {
        return
      }
      state.collection = upsertPifInCollection(state.collection, resource)
    }
  },
  actions: {
    resetCollection(context) {
      context.commit('set', {
        field: 'collection',
        value: []
      })
      context.dispatch('bootFor', [
        'where',
        'trip_dashboard_id',
        context.rootGetters.currentTripDashboardId
      ])
    },
    toggleUserAccess(context, payload) {
      if (payload.pifId && payload.userId) {
        return new Promise(resolve => {
          $axios
            .post(`${context.state.apiBaseUrl}/${payload.pifId}/toggleUserAccess/${payload.userId}`)
            .then(res => {
              if (res.status === 200) {
                context.commit('setOne', { resource: res.data })
                resolve()
              }
            })
        })
      }
    },
    updateDoesNotOwnEmail(context, payload) {
      if (!payload.pifId) {
        return
      }
      return $axios
        .post(`${context.state.apiBaseUrl}/${payload.pifId}/updateDoesNotOwnEmail`, {
          does_not_own_email: payload.doesNotOwnEmail
        })
        .then(res => {
          if (res.status === 200) {
            context.commit('set', {
              field: 'collection',
              value: patchCollectionDoesNotOwnEmailFields(context.state.collection, res.data)
            })
            return res.data
          }
          return Promise.reject(res)
        })
    },
    updateOrder(context, payload) {
      if (payload.pifId && payload.action) {
        return new Promise(resolve => {
          $axios
            .post(`${context.state.apiBaseUrl}/${payload.pifId}/updateOrder/${payload.action}`)
            .then(res => {
              if (res.status === 200) {
                context.commit('set', {
                  field: 'collection',
                  value: res.data
                })
                resolve()
              }
            })
        })
      }
    },
    createFromContact(context, payload) {
      return new Promise(resolve => {
        $axios
          .post(
            `${context.state.apiBaseUrl}/create-from-contact/${context.rootGetters.currentTripDashboardId}/${payload.contactId}`
          )
          .then(res => {
            if ([200,201].includes(res.status)) {
              context.commit('set', {
                field: 'collection',
                value: res.data
              })
              resolve()
            }
            else {
              console.error(res)
              throw new Error("Failed to create PIF from Contact.")
            }
          })
      })
    },

    //      INFUSIONSOFT DUPLICATES

    getInfusionsoftDuplicates(context, payload) {
      if (payload.id) {
        return new Promise((resolve, reject) => {
          $axios
            .get(`${context.state.apiBaseUrl}/${payload.id}/infusionsoft-duplicates`, payload.model)
            .then(res => {
              if (res.status === 200) {
                resolve(res.data)
              } else {
                reject()
              }
            })
        })
      }
    },

    updatePIFInCollection(context, payload) {
      context.commit('set', {
        field: 'collection',
        value: upsertPifInCollection(context.state.collection, payload.pif)
      })
    }
  },
  getters: {
    pifs: state => {
      return state.collection
    },
    attachments: (state, getters, rootState, rootGetters) => {
      if (rootGetters['AttachmentsV2/forQuery']) {
        return rootGetters['AttachmentsV2/forQuery']({
          owner_type: 'App\\Models\\PersonalInformationForm'
        })
      }
    }
  }
})
export default s
